import TrowelNavIcon from "../nav-icon";
import "./index.scss";
import goalWhiteIcon from "../../assets/media/icons/goalsWhiteIcon.png";
import dashboardIcon from "../../assets/media/icons/dashboard.png";
import insightIcon from "../../assets/media/icons/insights.png";
import insightWhiteIcon from "../../assets/media/icons/insightWhiteIcon.png";
import workspaceIcon from "../../assets/media/icons/chatTopMenuIcon.png";
import profileIcon from "../../assets/media/icons/companyProfileIcon.png";
import { ITrowelSideMenu } from "../../common/inerfaces/component-interfaces";

const menuList = [
  { label: "Dashboard", icon: dashboardIcon, path: '/dashboard', isActive: true },
  //{ label: "Insights", icon: insightWhiteIcon, path : '/insight', isActive: false},
  { label: "Goals", icon: goalWhiteIcon, path : '/goals', isActive: false},
  { label: "Profile", icon: profileIcon, path : '/profile', isActive: false},
  { label: "Workspace", icon: workspaceIcon, path : '/workspace', isActive: false},
  { label: "Design Studio", icon: insightWhiteIcon, path : '/designer-studio', isActive: false}
];

const TrowelSideMenu: React.FC<ITrowelSideMenu> = ({ onNavigationChange }) => {
  return (
    <nav className="trwl-nav">
      {menuList.map((menu) => (
        <TrowelNavIcon
          key={menu.label}
          menu={{ ...menu, src: menu.icon }}
          onSelected={onNavigationChange}
        />
      ))}
    </nav>
  );
};

export default TrowelSideMenu;
